import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  TextField, Button, Box, Typography, IconButton, Grid, List, ListItem,
  ListItemText, ListItemSecondaryAction, MenuItem, FormControlLabel, Checkbox, CircularProgress,
  Grid2,
  Divider
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { ApiRequest } from '../../services/api';

import { Alert } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const NewRecipe = () => {
  const [recipe, setRecipe] = useState({
    nombre: '',
    descripcion: '',
    tiempoPreparacion: '',
    tiempoCoccion: '',
    porciones: '',
    estatus: '',
    tipoCocinero: '',
    tiemposDelDia: [],
    categoria: '',
    momentoDia: '',
    clasificacionReceta: '',
    gastronomia: '',
    fitFat: '',
    temporada: '',
    alergeno: '',
    urlCompra: '',
    imagen: '',
    notaIdr: '',
    ingredientes: [],
    listaDePasos: [],
    informacionNutricional: [],
    etiquetasInformacionNutricional: [],
    urlVideo: '',
    metaTitle: '',
    metaDescription: '',
    keyWords: '',
    altText: '',
    altImage: ''
  });

  const [newIngredient, setNewIngredient] = useState({ ingredienteId: '', cantidad: '', instrucciones: '' });
  const [availableIngredients, setAvailableIngredients] = useState([]);
  const [newCategoria, setNewCategoria] = useState({ categoriaId: '' });
  const [availableCategoria, setAvailableCategoria] = useState([]);
  const [newTiempoDia, setNewTiempoDia] = useState({ tiempoDiaId: '' });
  const [availableTiempoDia, setAvailableTiempoDia] = useState([]);
  const [availableMomentoDia, setAvailableMomentoDia] = useState([]);
  const [availableClasificacionReceta, setAvailableClasificacionReceta] = useState([]);
  const [availableGastronomias, setAvailableGastronomias] = useState([]);
  const [availableFitFat, setAvailableFitFat] = useState([]);
  const [availableTemporada, setAvailableTemporada] = useState([]);
  const [availableAlergeno, setAvailableAlergeno] = useState([]);
  const [newMomentoDia, setNewMomentoDia] = useState({ momentoDiaId: '' });
  const [newClasificacionReceta, setNewClasificacionReceta] = useState({ clasificacionRecetaId: '' });
  const [newPaso, setNewPaso] = useState({ noPaso: '', descripcion: '', esTip: false });
  const [newInfoNutricional, setNewInfoNutricional] = useState({ id: '', nutriente: '', totalReceta: '', porPorcion: '', idr: '' });
  const [availableEtiquetasInformacionNutricional, setAvailableEtiquetasInformacionNutricional] = useState([]);
  const [newEtiquetaInformacionNutricional, setNewEtiquetaInformacionNutricional] = useState({ etiquetaId: '' });
  const [imagePreview, setImagePreview] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [uploadError, setUploadError] = useState('');
  const [videoFile, setVideoFile] = useState(null);
  const [videoPreview, setVideoPreview] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [uploadProgress, setUploadProgress] = useState(0);

  

  const handleVideoUpload = async () => {
    if (!videoFile) {
      setUploadError('Selecciona un archivo de video');
      return;
    }

    try {
      // Sanitizar nombre de archivo
      const sanitizedName = videoFile.name
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_.]/g, '');

      // Paso 1: Obtener Signed URL del backend

      const response = await ApiRequest('api/Media/firmar', 'POST', {
        nombreArchivo: sanitizedName,
        contentType: videoFile.type
      });

      if (!response || !response.url) {
        throw new Error('No se pudo obtener URL firmada');
      }

      const signedUrl = response.url;

      // Paso 2: Subir el archivo usando la signed URL
      const uploadResponse = await fetch(signedUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': videoFile.type
        },
        body: videoFile
      });

      if (!uploadResponse.ok) throw new Error('Error al subir el video');

      // const bucketName = process.env.GCP_BUCKET_NAME;
      // const basePath = process.env.GCP_BASE_PATH;
      const bucketName = window.GCP_BUCKET_NAME || "ghdz-bucket-hoy-toca-prd";
      const basePath = window.GCP_BASE_PATH || "hoytoca2025";

      // Establecer la URL final del archivo
      const publicUrl = `https://storage.googleapis.com/${bucketName}/${basePath}/videos_recetas/${sanitizedName}`;
      setVideoUrl(publicUrl);
      setUploadError('');

    } catch (error) {
      console.error(error);
      setUploadError(error.message || 'Error al subir video');
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await fetchCategoria();
      await fetchIngredients();
      await fetchTiempoDia();
      await fetchMomentoDia();
      await fetchClasificacionReceta();
      await fetchGastronomias();
      await fetchFitFat();
      await fetchTemporada();
      await fetchAlergeno();
      setLoading(false);
    }
    const fetchCategoria = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarCategoriasAlimenticias', 'GET');
        setAvailableCategoria(response);
      } catch (error) {
        console.error('Error fetching Categorias:', error);
      }
    };

    const fetchIngredients = async () => {
      try {
        const response = await ApiRequest('api/Ingrediente/ListarIngredientes', 'GET');
        // Ordenar alfabéticamente
        const sortedIngredients = [...response].sort((a, b) =>
          a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
        );
        setAvailableIngredients(sortedIngredients);
      } catch (error) {
        console.error('Error fetching ingredients:', error);
      }
    };

    const fetchTiempoDia = async () => {
      try {
        const response = await ApiRequest('api/TiemposDia/ListarTiemposDia', 'GET');
        setAvailableTiempoDia(response);
      } catch (error) {
        console.error('Error fetching tiempo dia:', error);
      }
    };

    const fetchMomentoDia = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarMomentosDia', 'GET');
        setAvailableMomentoDia(response);
      } catch (error) {
        console.error('Error fetching momento dia:', error);
      }
    };

    const fetchClasificacionReceta = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarClasificacionesDeReceta', 'GET');
        setAvailableClasificacionReceta(response);
      } catch (error) {
        console.error('Error fetching clasificacion receta:', error);
      }
    }

    const fetchGastronomias = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarGastronomias', 'GET');
        setAvailableGastronomias(response);
      } catch (error) {
        console.error('Error fetching clasificacion receta:', error);
      }
    }

    const fetchFitFat = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarMasFit', 'GET');
        setAvailableFitFat(response);
      } catch (error) {
        console.error('Error fetching clasificacion receta:', error);
      }
    }

    const fetchTemporada = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarTemporadas', 'GET');
        setAvailableTemporada(response);
      } catch (error) {
        console.error('Error fetching clasificacion receta:', error);
      }
    }

    const fetchAlergeno = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarAlergenos', 'GET');
        setAvailableAlergeno(response);
      } catch (error) {
        console.error('Error fetching clasificacion receta:', error);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    const fetcEtiquetaInfoNutricional = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarEtiquetasInformacionNutricional', 'GET');
        // Ordenar alfabéticamente
        const sortedEtiquetas = [...response].sort((a, b) =>
          a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
        );
        setAvailableEtiquetasInformacionNutricional(sortedEtiquetas);
      } catch (error) {
        console.error('Error fetching Etiquetas:', error);
      }
    };

    fetcEtiquetaInfoNutricional();
  }, []);

  const handleSave = async () => {
    const recetaData = {
      Nombre: recipe.nombre,
      Descripcion: recipe.descripcion,
      TiempoPreparacion: parseInt(recipe.tiempoPreparacion),
      TiempoCoccion: parseInt(recipe.tiempoCoccion),
      Porciones: parseInt(recipe.porciones),
      Estatus: recipe.estatus,
      TipoDeConcinero: recipe.tipoCocinero,
      TiemposDia: recipe.tiemposDelDia.map(i => i.tiempoDiaId),
      CategoriaAlimenticia: recipe.categoria,
      MomentoDia: recipe.momentoDia,
      ClasificacionReceta: recipe.clasificacionReceta,
      Gastronomia: recipe.gastronomia,
      FitFat: recipe.fitFat,
      Temporada: recipe.temporada,
      Alergeno: recipe.alergeno,
      UrlCompra: recipe.urlCompra,
      ImagenBase64: recipe.imagen,
      VideoUrl: videoUrl,
      NotaIdr: recipe.notaIdr,
      Ingredientes: recipe.ingredientes.map(i => ({
        IngredienteId: i.ingredienteId,
        Cantidad: i.cantidad,
        Instrucciones: i.instrucciones
      })),
      ListaDePasos: recipe.listaDePasos.map(i => ({
        NoPaso: i.noPaso,
        Descripcion: i.descripcion,
        EsTip: i.esTip
      })),
      InformacionNutricional: recipe.informacionNutricional.map(i => ({
        Nutriente: i.nutriente,
        TotalReceta: i.totalReceta,
        PorPorcion: i.porPorcion,
        Idr: i.idr
      })),
      EtiquetasInformacionNutricional: recipe.etiquetasInformacionNutricional.map(i => i.etiquetaId),
      MetaTitle: recipe.metaTitle,
      MetaDescription: recipe.metaDescription,
      KeyWords: recipe.keyWords,
      AltText: recipe.altText,
      AltImage: recipe.altImage
    };
    /*
    nombre: '',
    descripcion: '',
    tiempoPreparacion: '',
    tiempoCoccion: '',
    porciones: '',
    estatus: '',
    tipoCocinero: '',
    tiemposDelDia: [],
    categoria: '',
    momentoDia: '',
    urlCompra: '',
    imagen: '',
    notaIdr: '',
    ingredientes: [],
    listaDePasos: [],
    informacionNutricional: [],
    etiquetasInformacionNutricional: []
    */

    try {
      setLoading(true);
      await ApiRequest('api/Recetas', 'POST', recetaData);
      navigate('/Dashboard/Recetas');
    } catch (error) {
      console.error('Error saving new receta:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddIngredient = () => {
    if (newIngredient.ingredienteId && newIngredient.cantidad) {
      setRecipe({
        ...recipe,
        ingredientes: [...recipe.ingredientes, { ...newIngredient }]
      });
      setNewIngredient({ ingredienteId: '', cantidad: '', instrucciones: '' });
    }
  };

  const handleAddTiempoDia = () => {
    if (newTiempoDia.tiempoDiaId) {
      setRecipe({
        ...recipe,
        tiemposDelDia: [...recipe.tiemposDelDia, { ...newTiempoDia }]
      });
      setNewTiempoDia({ tiempoDiaId: '' });
    }
  };

  const handleAddEtiqueta = () => {
    if (newEtiquetaInformacionNutricional.etiquetaId) {
      setRecipe({
        ...recipe,
        etiquetasInformacionNutricional: [...recipe.etiquetasInformacionNutricional, { ...newEtiquetaInformacionNutricional }]
      });
      setNewEtiquetaInformacionNutricional({ etiquetaId: '' });
    }
  };




  const handleAddPaso = () => {
    if (newPaso.descripcion) {
      setRecipe({
        ...recipe,
        listaDePasos: [...recipe.listaDePasos, { ...newPaso }]
      });
      setNewPaso({ noPaso: '', descripcion: '', esTip: false });
    }
  };

  const handleAddInfoNutricional = () => {
    if (newInfoNutricional.nutriente && newInfoNutricional.totalReceta && newInfoNutricional.porPorcion && newInfoNutricional.idr) {
      setRecipe({
        ...recipe,
        informacionNutricional: [...recipe.informacionNutricional, { ...newInfoNutricional }]
      });
      setNewInfoNutricional({ id: '', nutriente: '', totalReceta: '', porPorcion: '', idr: '' });
    }
  };

  const handleDeleteIngredient = (ingredientId) => {
    setRecipe({
      ...recipe,
      ingredientes: recipe.ingredientes.filter(ingredient => ingredient.ingredienteId !== ingredientId)
    });
  };

  const handleDeleteTiempoDia = (tiempoDiaId) => {
    setRecipe({
      ...recipe,
      tiemposDelDia: recipe.tiemposDelDia.filter(tiempoDia => tiempoDia.tiempoDiaId !== tiempoDiaId)
    });
  };

  const handleDeleteEtiqueta = (etiquetaId) => {
    setRecipe({
      ...recipe,
      etiquetasInformacionNutricional: recipe.etiquetasInformacionNutricional.filter(item => item.etiquetaId !== etiquetaId)
    });
  };

  const handleDeletePaso = (noPaso) => {
    setRecipe({
      ...recipe,
      listaDePasos: recipe.listaDePasos.filter(paso => paso.noPaso !== noPaso)
    });
  };

  const handleDeleteInfoNutricional = (id) => {
    setRecipe({
      ...recipe,
      informacionNutricional: recipe.informacionNutricional.filter(paso => paso.id !== id)
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileSizeMB = file.size / (1024 * 1024); // Convertir bytes a MB

      if (fileSizeMB > 10) {
        alert("El archivo supera el límite de 10MB.");
        e.target.value = ""; // Limpiar el input
        return;
      }
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1];
        setRecipe({ ...recipe, imagen: base64String });
        setImagePreview(reader.result);
      };

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  };

  return (
    <Box sx={{ padding: 3 }}>
      {loading ? (
        <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
      ) : (
        <>
          <Typography variant="h4" gutterBottom>
            Agregar Receta
          </Typography>

          <TextField
            label="Nombre"
            value={recipe.nombre}
            onChange={(e) => setRecipe({ ...recipe, nombre: e.target.value })}
            fullWidth
            margin="normal"
          />

          <TextField
            label="Descripción"
            value={recipe.descripcion}
            onChange={(e) => setRecipe({ ...recipe, descripcion: e.target.value })}
            fullWidth
            margin="normal"
            multiline
            rows={4}
          />

          <Grid2 container size={12} spacing={2}>
            <Grid2 size={{ sm: 12, md: 4 }}>
              <TextField
                label="Tiempo de Preparación (min)"
                type="number"
                value={recipe.tiempoPreparacion}
                onChange={(e) => setRecipe({ ...recipe, tiempoPreparacion: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid2>

            <Grid2 size={{ sm: 12, md: 4 }}>
              <TextField
                label="Tiempo de Cocción (min)"
                type="number"
                value={recipe.tiempoCoccion}
                onChange={(e) => setRecipe({ ...recipe, tiempoCoccion: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid2>

            <Grid2 size={{ sm: 12, md: 4 }}>
              <TextField
                label="Porciones"
                type="number"
                value={recipe.porciones}
                onChange={(e) => setRecipe({ ...recipe, porciones: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid2>
          </Grid2>

          <Grid2 container size={12} spacing={2}>
            <Grid2 size={{ sm: 12, md: 4 }}>
              <TextField
                select
                label="Estatus"
                value={recipe.estatus}
                onChange={(e) => setRecipe({ ...recipe, estatus: e.target.value })}
                fullWidth
                margin="normal"
              >
                <MenuItem value="Publicado">Publicado</MenuItem>
                <MenuItem value="Borrador">Borrador</MenuItem>
              </TextField>
            </Grid2>

            <Grid2 size={{ sm: 12, md: 4 }}>
              <TextField
                select
                label="Tipo de cocinero"
                value={recipe.tipoCocinero}
                onChange={(e) => setRecipe({ ...recipe, tipoCocinero: e.target.value })}
                fullWidth
                margin="normal"
              >
                <MenuItem value="Básico">Básico</MenuItem>
                <MenuItem value="Intermedio">Intermedio</MenuItem>
                <MenuItem value="Avanzado">Avanzado</MenuItem>
                <MenuItem value="Experto">Experto</MenuItem>
              </TextField>
            </Grid2>


            <Grid2 size={{ sm: 12, md: 4 }}>
              <TextField
                select
                label="Categoría Alimenticia"
                value={newCategoria.categoriaId}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setNewCategoria({ ...newCategoria, categoriaId: selectedValue });
                  setRecipe({ ...recipe, categoria: selectedValue });
                }}
                fullWidth
                margin="normal"
              >
                {availableCategoria.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid2>
          </Grid2>

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                select
                label="Seleccionar Tiempos del día"
                value={newTiempoDia.tiempoDiaId}
                onChange={(e) => setNewTiempoDia({ ...newTiempoDia, tiempoDiaId: e.target.value })}
                fullWidth
                margin="normal"
              >
                {availableTiempoDia.map((tiempoDia) => (
                  <MenuItem key={tiempoDia.id} value={tiempoDia.id}>
                    {tiempoDia.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} alignContent={'center'}>
              <Button className="button" variant="contained" color="primary" onClick={handleAddTiempoDia}>
                Añadir tiempo del dia
                <svg fill="currentColor" viewBox="0 0 24 24" className="icon">
                  <path
                    clip-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </Button>

            </Grid>

          </Grid>

          <List>
            {recipe.tiemposDelDia.map((tiempoDia) => {
              const tiempoDiaDetails = availableTiempoDia.find((i) => i.id === tiempoDia.tiempoDiaId);
              return (
                <ListItem key={tiempoDia.tiempoDiaId}>
                  <ListItemText
                    primary={tiempoDiaDetails?.nombre || 'Tiempo del día no disponible'}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteTiempoDia(tiempoDia.tiempoDiaId)}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                select
                label="Momento del día"
                value={newMomentoDia.momentoDiaId}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setNewMomentoDia({ ...newMomentoDia, momentoDiaId: e.target.value });
                  setRecipe({ ...recipe, momentoDia: selectedValue });
                }}
                fullWidth
                margin="normal"
              >
                {availableMomentoDia.map((momentoDia) => (
                  <MenuItem key={momentoDia.id} value={momentoDia.id}>
                    {momentoDia.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>



            <Grid item xs={6}>
              <TextField
                select
                label="Clasificación de Receta"
                value={newClasificacionReceta.clasificacionRecetaId}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setNewClasificacionReceta({ ...newClasificacionReceta, clasificacionRecetaId: selectedValue });
                  setRecipe({ ...recipe, clasificacionReceta: selectedValue });
                }}
                fullWidth
                margin="normal"
              >
                {availableClasificacionReceta.map((clasificacion) => (
                  <MenuItem key={clasificacion.id} value={clasificacion.id}>
                    {clasificacion.nombre}
                  </MenuItem>
                ))}
              </TextField>

            </Grid>
          </Grid>

          <Grid container spacing={2}>

            {/* GASTRONOMÍA */}
            <Grid item xs={6}>
              <TextField
                select
                label="Gastronomía"
                value={recipe.gastronomia}
                onChange={(e) => setRecipe({ ...recipe, gastronomia: e.target.value })}
                fullWidth
                margin="normal"
              >
                {availableGastronomias.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* FIT/FAT */}
            <Grid item xs={6}>
              <TextField
                select
                label="Fit o Fat"
                value={recipe.fitFat}
                onChange={(e) => setRecipe({ ...recipe, fitFat: e.target.value })}
                fullWidth
                margin="normal"
              >
                {availableFitFat.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* TEMPORADA */}
            <Grid item xs={6}>
              <TextField
                select
                label="Temporada"
                value={recipe.temporada}
                onChange={(e) => setRecipe({ ...recipe, temporada: e.target.value })}
                fullWidth
                margin="normal"
              >
                {availableTemporada.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* ALÉRGENO */}
            <Grid item xs={6}>
              <TextField
                select
                label="Alérgeno"
                value={recipe.alergeno}
                onChange={(e) => setRecipe({ ...recipe, alergeno: e.target.value })}
                fullWidth
                margin="normal"
              >
                {availableAlergeno.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

          </Grid>



          <TextField
            label="URL compra"
            value={recipe.urlCompra}
            onChange={(e) => setRecipe({ ...recipe, urlCompra: e.target.value })}
            fullWidth
            margin="normal"
          />





          <Typography variant="h6" gutterBottom>
            Ingredientes
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={5}>
              <TextField
                select
                label="Seleccionar Ingrediente"
                value={newIngredient.ingredienteId}
                onChange={(e) => setNewIngredient({ ...newIngredient, ingredienteId: e.target.value })}
                fullWidth
                margin="normal"
              >
                {availableIngredients.map((ingredient) => (
                  <MenuItem key={ingredient.id} value={ingredient.id}>
                    {ingredient.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={2}>
              <TextField
                label="Cantidad"
                value={newIngredient.cantidad}
                onChange={(e) => setNewIngredient({ ...newIngredient, cantidad: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Instrucciones"
                value={newIngredient.instrucciones}
                onChange={(e) => setNewIngredient({ ...newIngredient, instrucciones: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={2} alignContent={'center'}>
              <Button className="button" variant="contained" color="primary" onClick={handleAddIngredient}>
                Añadir Ingrediente
                <svg fill="currentColor" viewBox="0 0 24 24" className="icon">
                  <path
                    clip-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </Button>
            </Grid>
          </Grid>

          <List>
            {recipe.ingredientes.map((ingredient) => {
              const ingredientDetails = availableIngredients.find((i) => i.id === ingredient.ingredienteId);
              return (
                <ListItem key={ingredient.ingredienteId}>
                  <ListItemText
                    primary={ingredientDetails?.nombre || 'Ingrediente no disponible'}
                    secondary={ingredient.cantidad}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteIngredient(ingredient.ingredienteId)}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />

          <TextField
            label="NotaIdr"
            value={recipe.notaIdr}
            onChange={(e) => setRecipe({ ...recipe, notaIdr: e.target.value })}
            fullWidth
            margin="normal"
          />




          <Typography variant="h6" gutterBottom>
            Pasos
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="Descripcion"
                value={newPaso.descripcion}
                onChange={(e) => setNewPaso({ ...newPaso, noPaso: recipe.listaDePasos.length + 1, descripcion: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={4} alignContent={'center'}>
              <FormControlLabel
                control={
                  <label className="container">
                    <input type="checkbox" checked={newPaso.esTip} onChange={(e) =>
                      setNewPaso({
                        ...newPaso,
                        noPaso: recipe.listaDePasos.length + 1,
                        esTip: e.target.checked
                      })
                    } />
                    <div className="checkmark"></div>
                  </label>

                }
                label="Es tip"
              />
            </Grid>
            <Grid item xs={2} alignContent={'center'}>
              <Button className="button" variant="contained" color="primary" onClick={handleAddPaso}>
                Añadir paso<svg fill="currentColor" viewBox="0 0 24 24" className="icon">
                  <path
                    clip-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </Button>
            </Grid>
          </Grid>

          <List>
            {recipe.listaDePasos.map((paso) => {
              return (
                <ListItem key={paso.noPaso}>
                  <ListItemText
                    primary={paso.noPaso + '.- ' + paso.descripcion}
                    secondary={'es tip: ' + paso.esTip}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeletePaso(paso.noPaso)}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />


          <Typography variant="h6" gutterBottom>
            Informacion Nutricional
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                label="Nutriente"
                value={newInfoNutricional.nutriente}
                onChange={(e) => setNewInfoNutricional({ ...newInfoNutricional, id: recipe.informacionNutricional.length + 1, nutriente: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                label="Total Receta"
                value={newInfoNutricional.totalReceta}
                onChange={(e) => setNewInfoNutricional({ ...newInfoNutricional, id: recipe.informacionNutricional.length + 1, totalReceta: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                label="Por Porcion"
                value={newInfoNutricional.porPorcion}
                onChange={(e) => setNewInfoNutricional({ ...newInfoNutricional, id: recipe.informacionNutricional.length + 1, porPorcion: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                label="Idr"
                value={newInfoNutricional.idr}
                onChange={(e) => setNewInfoNutricional({ ...newInfoNutricional, id: recipe.informacionNutricional.length + 1, idr: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={2} alignContent={'center'}>
              <Button className="button" variant="contained" color="primary" onClick={handleAddInfoNutricional}>
                Añadir Informacion<svg fill="currentColor" viewBox="0 0 24 24" className="icon">
                  <path
                    clip-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </Button>
            </Grid>
          </Grid>

          <List>
            {recipe.informacionNutricional.map((paso) => {
              return (
                <ListItem key={paso.id}>
                  <ListItemText
                    primary={paso.id + '.- ' + paso.nutriente}
                    secondary={'' + paso.totalReceta + ' ' + paso.porPorcion + ' ' + paso.idr}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteInfoNutricional(paso.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />




          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                select
                label="Seleccionar Etiquetas de informacion nutricional"
                value={newEtiquetaInformacionNutricional.etiquetaId}
                onChange={(e) => setNewEtiquetaInformacionNutricional({ ...newEtiquetaInformacionNutricional, etiquetaId: e.target.value })}
                fullWidth
                margin="normal"
              >
                {availableEtiquetasInformacionNutricional.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} alignContent={'center'}>
              <Button className="button" variant="contained" color="primary" onClick={handleAddEtiqueta}>
                Añadir etiqueta<svg fill="currentColor" viewBox="0 0 24 24" className="icon">
                  <path
                    clip-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </Button>
            </Grid>

          </Grid>

          <List>
            {recipe.etiquetasInformacionNutricional.map((item) => {
              const foundedItem = availableEtiquetasInformacionNutricional.find((i) => i.id === item.etiquetaId);
              return (
                <ListItem key={item.tiempoDiaId}>
                  <ListItemText
                    primary={foundedItem?.nombre || 'Tiempo del día no disponible'}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteEtiqueta(item.etiquetaId)}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />



          <Typography variant="h6" gutterBottom>
            Imagen de la Receta
          </Typography>
          <button className="upload-file-button">
            <svg
              aria-hidden="true"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeWidth="2"
                stroke="#fffffff"
                d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H11M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125"
                strokeLinejoin="round"
                strokeLinecap="round"
              ></path>
              <path
                strokeLinejoin="round"
                strokeLinecap="round"
                strokeWidth="2"
                stroke="#fffffff"
                d="M17 15V18M17 21V18M17 18H14M17 18H20"
              ></path>
            </svg>
            Cargar Imagen
            <input type="file" accept="image/*" onChange={handleImageChange} />
          </button>


          {imagePreview && (
            <Box mt={2}>
              <img src={imagePreview} alt="Vista previa de la receta" style={{ width: '100%', maxHeight: '300px', objectFit: 'contain' }} />
            </Box>
          )}

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />

          {/* Sección de Video */}
          <Typography variant="h6" gutterBottom>
            Video de la Receta
          </Typography>
          <button className="upload-file-button">
            <svg
              aria-hidden="true"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeWidth="2"
                stroke="#fffffff"
                d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H11M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125"
                strokeLinejoin="round"
                strokeLinecap="round"
              ></path>
              <path
                strokeLinejoin="round"
                strokeLinecap="round"
                strokeWidth="2"
                stroke="#fffffff"
                d="M17 15V18M17 21V18M17 18H14M17 18H20"
              ></path>
            </svg>
            Cargar Video
            <input
              type="file"
              accept="video/mp4,video/webm,video/ogg"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file && file.size > 100 * 1024 * 1024) { // Límite de 100MB
                  setUploadError('El video no puede superar 100MB');
                  return;
                }
                setVideoFile(file);
                setVideoPreview(URL.createObjectURL(file));
                setUploadError('');
              }}
              style={{ display: 'block', margin: '10px 0' }}
            />
          </button>


          {videoPreview && (
            <Box mt={2}>
              <video
                controls
                src={videoPreview}
                style={{ width: '100%', maxHeight: '300px', borderRadius: '8px' }}
              />
            </Box>
          )}

          {uploadError && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {uploadError}
            </Typography>
          )}
          <Grid container spacing={2} alignItems="center" sx={{ mt: 1, mb: 2 }}>
            <Grid item>

              <Button
                variant="contained"
                color="secondary"
                onClick={handleVideoUpload}
                disabled={!videoFile || uploadProgress > 0}
                sx={{ mt: 1, mb: 2 }}
              >
                {uploadProgress > 0 ? 'Subiendo...' : 'Subir Video'}
              </Button>
            </Grid>
            {videoUrl && (
              <Grid item>
                <Button
                  variant="contained"
                  color="error"
                  onClick={async () => {
                    try {
                      // 1. Extraer nombre del archivo desde la URL
                      // const bucketName = process.env.GCP_BUCKET_NAME;
                      // const basePath = process.env.GCP_BASE_PATH;
                      const bucketName = window.GCP_BUCKET_NAME || "ghdz-bucket-hoy-toca-prd";
                      const basePath = window.GCP_BASE_PATH || "hoytoca2025";

                      const fileName = videoUrl.replace(`https://storage.googleapis.com/${bucketName}/${basePath}/videos_recetas/`, '');

                      // 2. Pedir una signed URL al backend para eliminar ese archivo
                      const response = await ApiRequest('api/Media/firmar', 'POST', {
                        nombreArchivo: fileName,
                        contentType: 'video/mp4',
                        metodo: 'DELETE' // este nuevo campo permite firmar para DELETE
                      });

                      if (!response || !response.url) {
                        throw new Error('No se pudo obtener URL firmada para eliminar');
                      }

                      const signedDeleteUrl = response.url;

                      // 3. Hacer el DELETE directamente a la signed URL
                      const deleteResponse = await fetch(signedDeleteUrl, {
                        method: 'DELETE',
                      });

                      if (!deleteResponse.ok) {
                        throw new Error('Error eliminando el video');
                      }

                      // 4. Resetear estados
                      setVideoUrl('');
                      setVideoFile(null);
                      setVideoPreview('');
                      setUploadError('Video eliminado exitosamente');

                    } catch (error) {
                      setUploadError(error.message);
                    }
                  }}
                  sx={{ mt: 1, mb: 2 }}
                >
                  Eliminar Video
                </Button>
              </Grid>
            )}
          </Grid>
          {videoUrl && (
            <Alert
              severity="success"
              sx={{ mt: 2 }}
              action={
                <IconButton
                  size="small"
                  onClick={() => navigator.clipboard.writeText(videoUrl)}
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              }
            >
              Video subido exitosamente
            </Alert>
          )}

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />

          <Typography variant="h6" gutterBottom>
            Metadatos SEO
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Meta Título"
                value={recipe.metaTitle}
                onChange={(e) => setRecipe({ ...recipe, metaTitle: e.target.value })}
                fullWidth
                margin="normal"
                helperText="Máximo 70 caracteres"
                inputProps={{ maxLength: 70 }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Meta Descripción"
                value={recipe.metaDescription}
                onChange={(e) => setRecipe({ ...recipe, metaDescription: e.target.value })}
                fullWidth
                margin="normal"
                multiline
                rows={3}
                helperText="Máximo 160 caracteres"
                inputProps={{ maxLength: 160 }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Palabras Clave"
                value={recipe.keyWords}
                onChange={(e) => setRecipe({ ...recipe, keyWords: e.target.value })}
                fullWidth
                margin="normal"
                helperText="Separadas por comas"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Texto Alternativo (Alt Text)"
                value={recipe.altText}
                onChange={(e) => setRecipe({ ...recipe, altText: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Imagen Alternativa (Alt Image)"
                value={recipe.altImage}
                onChange={(e) => setRecipe({ ...recipe, altImage: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
          </Grid>

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button className="button" variant="contained" color="primary" onClick={handleSave}>
                Guardar Receta<svg fill="currentColor" viewBox="0 0 24 24" className="icon">
                  <path
                    clip-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </Box>

  );
};

export default NewRecipe;
